module.exports = __webpack_public_path__ + "static/img/got_2_box.6bbffd7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/answer_pop_up/got_2_box.png
// module id = okVs
// module chunks = 1